import React, { createContext, useContext, useState } from 'react';
import { Parameter } from '../dtos';

type State = {
    parameters: Parameter | null;
    setParameters: React.Dispatch<React.SetStateAction<Parameter | null>>;
};

type Props = {
    children: React.ReactNode;
};

const ParameterContext = createContext<State>({} as State);

const ParameterProvider: React.FC<Props> = ({ children }) => {
    const [parameters, setParameters] = useState<Parameter | null>(null);

    return (
        <ParameterContext.Provider
            value={{
                parameters,
                setParameters,
            }}
        >
            {children}
        </ParameterContext.Provider>
    );
};

const useParameter = (): State => {
    const context = useContext(ParameterContext);

    return context;
}

export { ParameterProvider, useParameter };